/** sessionStorage key so ?roomPicker=1 survives saveToCloud redirect to /floorplan/:id */
export const ROOM_PICKER_SESSION_KEY = "boni_roomPicker";

/**
 * True when the URL or session flag requests the room-picker wizard.
 * Also persists the flag when found in the URL so it survives the blank→id redirect.
 */
export function shouldOpenRoomPicker(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("roomPicker") === "1") {
      persistRoomPickerFlag();
      // Strip query param without a full reload.
      params.delete("roomPicker");
      const qs = params.toString();
      const nextUrl =
        window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash;
      window.history.replaceState({}, document.title, nextUrl);
      return true;
    }
    return sessionStorage.getItem(ROOM_PICKER_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function persistRoomPickerFlag(): void {
  try {
    sessionStorage.setItem(ROOM_PICKER_SESSION_KEY, "1");
  } catch {
    // ignore quota / private mode
  }
}

export function clearRoomPickerFlag(): void {
  try {
    sessionStorage.removeItem(ROOM_PICKER_SESSION_KEY);
  } catch {
    // ignore
  }
}
